import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Breadcrumb.module.css';

// Home icon SVG component
const HomeIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
  </svg>
);

// Chevron separator SVG component
const ChevronIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
  </svg>
);

/**
 * Breadcrumb component for navigation
 * @param {Array} items - Array of breadcrumb items { label, path }
 * @param {string} currentPage - Current page label (not clickable)
 */
const Breadcrumb = ({ items = [], currentPage }) => {
  const navigate = useNavigate();

  const handleNavigate = (path, state) => {
    if (path) {
      navigate(path, state !== undefined ? { state } : undefined);
    }
  };

  // Check if first item is home/dashboard
  const isHomeItem = (label) => {
    const homeLabels = ['home', 'dashboard', 'athena'];
    return homeLabels.includes(label.toLowerCase());
  };

  return (
    <div className={styles.breadcrumbContainer}>
      <nav className={styles.breadcrumb}>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <button
              className={styles.breadcrumbItem}
              onClick={() => handleNavigate(item.path, item.state)}
              type="button"
              title={item.label}
            >
              {index === 0 && isHomeItem(item.label) ? (
                <HomeIcon className={styles.homeIcon} />
              ) : (
                item.label
              )}
            </button>
            <ChevronIcon className={styles.separator} />
          </React.Fragment>
        ))}
        <span className={`${styles.breadcrumbItem} ${styles.current}`}>
          {currentPage}
        </span>
      </nav>
    </div>
  );
};

export default Breadcrumb;
